import styled from 'styled-components';

interface StyledStickyContainerProps {
  top: number;
  zIndex: number;
  backgroundColor: string;
}

export const StyledStickyContainer = styled.div<StyledStickyContainerProps>`
  position: sticky;
  top: ${props => props.top}px;
  z-index: ${props => props.zIndex};
  background-color: ${props => props.backgroundColor};
  width: 100%;
  transition: box-shadow 0.3s ease;

  &:after {
    content: '';
    display: block;
    height: 1px;
    width: 100%;
    background: transparent;
  }
`; 